import React from 'react';
import { connect } from 'react-redux';
import { UncontrolledAlert } from 'reactstrap';
import { getTranslationKey } from '../../modules/utils/helpers';

interface MaintenanceAlertProps {
  maintenance_mode: string | null;
}

interface StateProps {
  auth: {
    maintenance_mode: string | null;
  };
}

const MaintenanceAlert: React.FC<MaintenanceAlertProps> = ({ maintenance_mode }) => {
  if (!maintenance_mode) {
    return null;
  }

  let disabledFunctionsText = '';

  maintenance_mode.split(',').forEach((mode) => {
    if (!disabledFunctionsText) {
      disabledFunctionsText = getTranslationKey(`maintenance.modes.${mode}`);
    } else {
      disabledFunctionsText += ', ' + getTranslationKey(`maintenance.modes.${mode}`);
    }
  });

  return (
    <UncontrolledAlert
      id="discount-key-alert"
      className="discount-alert-margins m-0"
      color="danger"
    >
      {getTranslationKey('maintenance.prefix')}
      {disabledFunctionsText}
    </UncontrolledAlert>
  );
};

function mapStateToProps({ auth: { maintenance_mode } }: StateProps) {
  return { maintenance_mode };
}

export default connect(mapStateToProps, null)(MaintenanceAlert);
